const APP_TITLE = "Request for Evidence application";
const helpDeskNumbers = {
  row1: [
    "components.layout.elements.MenuHeader.Menu.HelpDesk.Number1",
    "components.layout.elements.MenuHeader.Menu.HelpDesk.Number1",
    "components.layout.elements.MenuHeader.Menu.HelpDesk.Number1",
    "components.layout.elements.MenuHeader.Menu.HelpDesk.Number1"
  ],

  row2: [
    "components.layout.elements.MenuHeader.Menu.HelpDesk.Number1",
    "components.layout.elements.MenuHeader.Menu.HelpDesk.Number1",
    "components.layout.elements.MenuHeader.Menu.HelpDesk.Number1",
    "components.layout.elements.MenuHeader.Menu.HelpDesk.Number1"
  ],
  row3: [
    "components.layout.elements.MenuHeader.Menu.HelpDesk.Number1",
    "components.layout.elements.MenuHeader.Menu.HelpDesk.Number1",
    "components.layout.elements.MenuHeader.Menu.HelpDesk.Number1",
    "components.layout.elements.MenuHeader.Menu.HelpDesk.Number1"
  ],
  row4: [
    "components.layout.elements.MenuHeader.Menu.HelpDesk.Number1",
    "components.layout.elements.MenuHeader.Menu.HelpDesk.Number1",
    "components.layout.elements.MenuHeader.Menu.HelpDesk.Number1",
    "components.layout.elements.MenuHeader.Menu.HelpDesk.Number1"
  ]
};

const TIMEOUT_LIMIT = "Time limit exceeded in Endpoint";

export { APP_TITLE, helpDeskNumbers, TIMEOUT_LIMIT };
